import {
  Outlet,
  createFileRoute,
  useChildMatches,
  useNavigate,
} from '@tanstack/react-router';
import { CategoryForm } from '@/pages/preferences/tabs/categories/form';
import { PROTECTED, SETTINGS } from '@/lib/constants/routes';
import { useCategoryDetail } from '@/api/category/use-category-detail';

export const Route = createFileRoute(
  '/protected/_layout/settings/_layout/categories/$id'
)({
  component: CategoryRoute,
});

/**
 * `categories/$id/keywords` è una rotta FIGLIA di questa: senza `Outlet` il
 * dialogo delle parole chiave non compariva mai e restava il form completo.
 * Con una figlia attiva si mostra solo lei.
 */
function CategoryRoute() {
  const childMatches = useChildMatches();
  if (childMatches.length > 0) return <Outlet />;
  return <EditCategoryModal />;
}

function EditCategoryModal() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const { data } = useCategoryDetail(id);

  // Fetch parent category for subcategories to show correct header
  const { data: parentCategory } = useCategoryDetail(
    data?.parentId ?? undefined
  );

  const handleClose = () => {
    navigate({
      to: `${PROTECTED}${SETTINGS}`,
      search: (old) => ({
        ...old,
        tab: 'category',
        subTab: 'list',
      }),
    });
  };

  return (
    <CategoryForm
      modalOpen={true}
      id={id}
      onModalClose={handleClose}
      data={data}
      parentId={data?.parentId ?? undefined}
      parentCategory={parentCategory}
    />
  );
}
